/*
 * @Author: YuanYuan
 * @Date: 2024-02-23 18:11:04
 * @LastEditTime: 2025-09-08 10:44:02
 * @Description: 网站接入接口集合
 */
const prefix = process.env.VUE_APP_API_PREFIX

export default [
  {
    name: 'tableQuery',
    path: `${prefix}/domain/list`,
    method: 'get',
    params: {
      page: 1,
      limit: 10,
      domain: '',
      https: '',
      ip: '',
      groupId: '',
      status: ''
    },
    desc: '网站接入列表'
  },
  {
    name: 'deleteDomains',
    path: `${prefix}/domain/delete_batch`,
    method: 'post',
    params: {
      domains: ''
    },
    desc: '删除域名'
  },
  {
    name: 'enableDomains',
    path: `${prefix}/domain/enableDomains`,
    method: 'post',
    params: {
      domains: ''
    },
    desc: '启用域名'
  },
  {
    name: 'changeOrigin',
    path: `${prefix}/domain/change_ip_batch`,
    method: 'post',
    params: {
      domains: '',
      sourceType: '',
      ips: ''
    },
    desc: '换源'
  },
  {
    name: 'domainAdd',
    path: `${prefix}/domain/add`,
    method: 'post',
    params: {
      packageId: '', // 套餐
      line: '', // 区域
      domain: '', // 域名
      ip: '', // 源站IP/域名内容
      groupId: '', // 域名组
      https: '', // 协议类型是否勾选了https
      cert: '', // https证书
      websocket: '', // 开启WebSocket
      referenceDomain: '', // 加速配置参考域名
      mode: '', // 防护配置模式
      sourceDomain: '', // 防护配置参照已有域名安全配置的参照域名
      config: {} // 防护配置内容
    },
    desc: '新增域名'
  },
  {
    name: 'domainDetails',
    path: `${prefix}/domain/details`,
    method: 'get',
    params: {
      domain: ''
    },
    desc: '获取域名详情'
  },
  {
    name: 'cacheDetails',
    path: `${prefix}/domain/get_cust_cache`,
    method: 'get',
    params: {
      domain: ''
    },
    desc: '获取缓存详情'
  },
  {
    name: 'relateCert',
    path: `${prefix}/domain/cert_relate`,
    method: 'post',
    params: {
      domain: '',
      cert: '',
      https: ''
    },
    desc: '关联证书'
  },
  {
    name: 'areaChange',
    path: `${prefix}/domain/domain_edit`,
    method: 'post',
    params: {
      domain: '',
      packageId: '',
      line: ''
    },
    desc: '区域变更'
  },
  {
    name: 'websocketChange',
    path: `${prefix}/domain/domain_edit`,
    method: 'post',
    params: {
      websocket: '',
      domain: ''
    },
    desc: 'websocket变更'
  },
  {
    name: 'httpsDetails',
    path: `${prefix}/domain/detail_https`,
    method: 'get',
    params: {
      domain: ''
    },
    desc: 'HTTPS详情'
  },
  {
    name: 'originDetails',
    path: `${prefix}/domain/detail_change_ip`,
    method: 'get',
    params: {
      domains: ''
    },
    desc: '换源详情'
  },
  {
    name: 'domainsByPkgId',
    path: `${prefix}/domain/getDomainByPid`,
    method: 'get',
    params: {
      pid: ''
    },
    desc: '通过套餐id获取域名列表'
  },
  {
    name: 'domainConfiguration',
    path: `${prefix}/domain/getDomainConfiguration`,
    method: 'get',
    params: {
      domain: '',
      packageId: ''
    },
    desc: '参考域名配置'
  },
  {
    name: 'systemConfiguration',
    path: `${prefix}/domain/getSystemSuggestConfiguration`,
    method: 'get',
    params: {
      packageId: ''
    },
    desc: '推荐配置'
  },
  {
    name: 'confirmConfig',
    path: `${prefix}/domain/confirmConfig`,
    method: 'post',
    params: {
      domains: '',
      cacheTimeRule: [],
      requestProtocol: [],
      originProtocol: [],
      replaceProtocol: {},
      websocket: '',
      dataOpt: ''
    },
    desc: '确认配置信息'
  },
  {
    name: 'deployConfig',
    path: `${prefix}/domain/deploy`,
    method: 'post',
    params: {
      domains: '',
      dataOpt: '',
      confirmResult: []
    },
    desc: '部署配置'
  },
  {
    name: 'domainPackages',
    path: `${prefix}/package/getUserSimpleList`,
    method: 'get',
    params: {},
    desc: '域名套餐列表'
  }
]
